import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InputGroupComponent } from './input-group.component';

export interface IResponsiveColumnsMap {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

const BREAKPOINT_ALIASES: Array<[keyof IResponsiveColumnsMap, string]> = [
  ['xs', Breakpoints.XSmall],
  ['sm', Breakpoints.Small],
  ['md', Breakpoints.Medium],
  ['lg', Breakpoints.Large],
  ['xl', Breakpoints.XLarge],
];

// Usage: <odq-input-group [responsiveGutter]="{xs: 2, sm: 2, md: 4, lg: 6, xl: 8}">
@Directive({
    selector: '[responsiveGutter]',
    standalone: false
})
export class ResponsiveGutterDirective implements OnInit, OnDestroy {
  private countBySize: IResponsiveColumnsMap = { xs: 2, sm: 2, md: 4, lg: 6, xl: 8 };
  destroy$ = new Subject<void>();

  public get cols(): IResponsiveColumnsMap {
    return this.countBySize;
  }

  @Input('responsiveGutter')
  public set cols(map: IResponsiveColumnsMap) {
    if (map && (typeof map === 'object')) {
      this.countBySize = map;
    }
  }

  public constructor(
    private inputGroup: InputGroupComponent,
    private breakpointObserver: BreakpointObserver,
  ) {}

  public ngOnInit(): void {
    this.applyGutterForCurrentBreakpoint();

    this.breakpointObserver
      .observe(BREAKPOINT_ALIASES.map(([, query]) => query))
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.applyGutterForCurrentBreakpoint());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyGutterForCurrentBreakpoint(): void {
    for (const [alias, query] of BREAKPOINT_ALIASES) {
      if (this.breakpointObserver.isMatched(query) && this.countBySize[alias] !== undefined) {
        this.inputGroup.Gutter = this.countBySize[alias];
        return;
      }
    }
  }
}
